import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-age-filter',
  templateUrl: './age-filter.component.html',
  styleUrls: ['./age-filter.component.scss'],
})
export class AgeFilterComponent implements OnInit {
  noWarning: boolean;
  noCookies: boolean;

  constructor() {
    this.noWarning = true;
    this.noCookies = false;
  }

  ngOnInit(): void {}

  isAgeInputEmpty(): boolean {
    if ((document.getElementById('date') as HTMLInputElement).value != '') {
      return false;
    }
    return true;
  }

  isWarningActive(): boolean {
    return this.noWarning;
  }

  closeWarning() {
    this.noWarning = true;
  }

  checkAge() {
    let date = (document.getElementById('date') as HTMLInputElement).value;
    let today = new Date();
    let birthDate = new Date(date);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    let d = today.getDay() - birthDate.getDay();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age >= 18) {
      window.location.replace('/inicio');
    } else {
      this.noWarning = false;
    }
  }

  hideCookies() {
    this.noCookies = true;
  }
}
